import Axios, { AxiosError } from 'axios';
import { Toast } from './common/types/models';
import M from 'materialize-css';

export const toast = (obj: Toast): void => {
  if (obj && obj.payload && typeof obj.payload === 'object') {
    M.toast({
      ...obj.payload,
      html: obj.payload.msg,
      classes: obj.payload.class,
    });
  }
};

export const logout = (err: string | AxiosError<Toast>): void => {
  try {
    if (typeof err === 'string') {
      toast({
        payload: {
          msg: err,
          class: 'red white-text',
        },
      });
      return;
    }

    if (!Array.isArray(err) && typeof err === 'object') {
      if (!Axios.isCancel(err)) {
        if (err.response) {
          if (err.response.status === 401) {
            localStorage.clear();
            window.location.replace('/');

            toast({
              payload: {
                msg: 'Not Authenticated',
                class: 'orange white-text',
              },
            });
          } else {
            toast(err.response.data);
          }
        }
      }
    }
  } catch {
    toast({
      payload: {
        msg: 'An Unknown Error Occurred.',
        class: 'red white-text',
      },
    });
  }
};

export const isValidEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
